module.exports = __webpack_public_path__ + "img/mq3.20a37e4b.png";